import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
// import BootstrapTable from 'react-bootstrap-table-next';
// import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import '../subscriptions.css';
// import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
// import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
// import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';


class ViewContracts extends Component {
    constructor(props) {
        super(props);
      }

  render() {
    return (

    <div className="modal fade" id="view_contracts_modal" tabIndex="-1" role="dialog" aria-labelledby="RejectModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">Contract Details</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <div className="col-xs-12 col-sm-8 col-md-8 col-lg-12">
                        <div className="m-portlet m-portlet--full-height ">
                            <div className="m-portlet m-portlet--success m-portlet--head-solid-bg" style={{boxShadow: 'none'}}>
                                <div className="m-portlet__head">
                                    <div className="m-portlet__head-caption">
                                        <div className="m-portlet__head-title">
                                            <h3 className="m-portlet__head-text">Pet Information</h3>
                                        </div>
                                    </div>
                                </div>
                                <div className="m-portlet__body">
                                    <div className="m-widget4">
                                        <div className="row align-items-center mt-4">
                                            <div className="col-lg-4 col-sm-12">
                                                <div className="row">
                                                    <div className="m-widget4__img m-widget4__img--pic  mx-auto my-2 user-avatar">
                                                        <img src="https://s3.amazonaws.com/uploads.development.petpos/uploads/4/medical-records/avatar/1539940222832_116204.jpg" alt=""/>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="m-widget4__info  mx-auto">
                                                        <span className="m-widget4__title">boxer</span>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <span className="m-badge m-badge--info mx-auto my-0 px-2"><strong>Id: </strong>1121</span>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-sm-12">
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                        <i className="fas fa-birthday-cake mr-2"></i>
                                                    <span><strong>Birthday: </strong></span>2018-08-07</span>
                                                </div>
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                        <i className="fas fa-microchip mr-2"></i>
                                                    <span><strong>Microchip: </strong>
                                                    </span>4566</span>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-sm-12">
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                        <i className="fas fa-genderless mr-2"></i>
                                                    <span><strong>Sex: </strong></span>male</span>
                                                </div>
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                        <i className="fas fa-paint-brush mr-2"></i>
                                                    <span><strong>Color: </strong></span>black</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-8 col-md-8 col-lg-12">
                        <div className="m-portlet m-portlet--full-height ">
                            <div className="m-portlet m-portlet--success m-portlet--head-solid-bg" style={{boxShadow: 'none'}}>
                                <div className="m-portlet__head">
                                    <div className="m-portlet__head-caption">
                                        <div className="m-portlet__head-title">
                                            <h3 className="m-portlet__head-text">Customer Information</h3>
                                        </div>
                                    </div>
                                </div>
                                <div className="m-portlet__body">
                                    <div className="m-widget4">
                                        <div className="row mt-4">
                                            <div className="col-md-6">
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                        <i className="fas fa-user mr-2"></i>
                                                    <span><strong>First Name: </strong></span>Kavinda Silva</span>
                                                </div>
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                        <i className="fas fa-user mr-2"></i>
                                                    <span><strong>Last Name: </strong></span></span>
                                                </div>
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                        <i className="fas fa-map-signs mr-2"></i>
                                                    <span><strong>City: </strong></span>Panadura</span>
                                                </div>
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                        <i className="fas fa-map-pin mr-2"></i>
                                                    <span><strong>Zip Code: </strong></span>12550</span>
                                                </div>
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                        <i className="fas fa-phone mr-2"></i>
                                                    <span><strong>Primary Phone (): </strong></span>+0772000919</span>
                                                </div>
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                        <i className="fas fa-search mr-2"></i>
                                                    <span><strong>How did you find us: </strong></span>Drive By</span>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                        <i className="fas fa-map-marker-alt mr-2"></i>
                                                    <span><strong>Street Address: </strong></span>220, Diggala Rd, Keselwatta</span>
                                                </div>
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub"><i className="fas fa-map-marker-alt mr-2"></i><span>
                                                    <strong>Apt/Suit/Building: </strong></span></span>
                                                </div>
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                        <i className="fas fa-map-signs mr-2"></i>
                                                    <span><strong>State: </strong></span>Western</span>
                                                </div>
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                        <i className="fas fa-phone mr-2"></i><span>
                                                    <strong>Secondary Phone (): </strong></span>+94112612627</span>
                                                </div>
                                                <div className="m-widget4__item">
                                                    <span className="m-widget4__sub">
                                                        <i className="fas fa-envelope mr-2"></i>
                                                    <span><strong>Email: </strong></span>kavindasilva2005@gmail.com</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>                   
                    <div className="col-xs-12 col-sm-8 col-md-8 col-lg-12">
                        <div className="m-portlet m-portlet--success m-portlet--head-solid-bg m-portlet--full-height ">
                            <div className="m-portlet__head">
                                <div className="m-portlet__head-caption">
                                    <div className="m-portlet__head-title">
                                        <h3 className="m-portlet__head-text">Payment Information</h3>
                                    </div>
                                </div>
                            </div>
                            <div className="m-portlet__body">
                                <div className="m-widget4">
                                    <div className="row">
                                        <div className="m-form form-group m-form__group col-md-12">
                                            <div className="m-widget4__item mt-5">
                                                <div className="m-accordion m-accordion--default" id="m_accordion_4" role="tablist">
                                                    <div className="m-accordion__item">
                                                        <div className="m-accordion__item-head collapsed" role="tab" id="m_accordion_4_item_0_head" data-toggle="collapse" href="#m_accordion_4_item_0_body" aria-expanded="false">
                                                            <span className="m-accordion__item-icon">
                                                                <i className="la la-money"></i></span>
                                                            <span className="m-accordion__item-title">Payment 1 - Cash</span>
                                                            <span className="m-accordion__item-mode"></span>
                                                        </div>
                                                        <div className="m-accordion__item-body collapse" id="m_accordion_4_item_0_body" role="tabpanel" aria-labelledby="m_accordion_4_item_0_head" data-parent="#m_accordion_4">
                                                            <div className="m-accordion__item-content">
                                                                <div className="m-widget4__item">
                                                                    <span className="m-widget4__sub">
                                                                    <i className="fas fa-dollar-sign mr-2"></i><span><strong>Amount: </strong></span>56465</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
  }
}

const mapStateToProps = state => ({
  user: state.cognito.user,
});


export default withRouter(connect(mapStateToProps)(ViewContracts));